<template>
  <div class="mapFilterContainer">
    <Toggle ref="toggle" @update:value="toggleUpdate" :defaultValue="getDefaultValue"></Toggle>
    <ToggleLabel :iconSrc="iconSrc" :name="name" />
  </div>
</template>

<script>
import Toggle from '@wizer/core/components/toggle/Toggle'
import ToggleLabel from './ToggleLabel'

export default {
  /**
   * Name of the component
   */
  name: 'MapFilterOption',

  /**
   * Components
   */
  components: {
    Toggle,
    ToggleLabel,
  },

  /**
   * This components properties
   */
  props: {
    name: String,
    id: String,
    iconSrc: String,
    showPinsOnload: Boolean,
  },
  /**
   * Computed methods
   */
  computed: {
    /**
     * Get default value based on the show filter panel flag
     */
    getDefaultValue() {
      const defaultValue = this.showPinsOnload === true
      if (defaultValue) {
        this.toggleUpdate(true)
        return defaultValue.toString()
      }
      return ''
    },
  },
  /**
   * Component methods
   */
  methods: {
    /**
     * Receives toggle updates and emit a toggle event
     * @param value current toggle value
     */
    toggleUpdate(value) {
      this.$emit('toggleUpdate', { id: this.id, value, type: 'mapFilterOptionUpdated' })
    },
  },
}
</script>
<style lang="postcss" scoped>
.mapFilterContainer {
  @apply flex;
}
</style>
